import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {FNP_APPLICATION_VERSION} from './constants';

export function FnpTranslationsLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + FNP_APPLICATION_VERSION);
}